import React from 'react';
import {Field, formValueSelector} from 'redux-form';
import {connect} from 'react-redux';
import _ from 'lodash';

const selector = formValueSelector( 'gratisForm' );

const formatAddress = ( addr ) => {
    /*
     { "city": "OXFORD", "country": "United Kingdom", "countrycode": "GB", "geocodeaccuracy": null,
     "latitude": null, "longitude": null, "postalcode": "OX2 6PN", "state": null, "statecode": null,
     "street": "64 Banbury Road" }
     */
    if ( addr.statecode ) {
        // US/CA format
        return `
        <div>${addr.street}</div>
        <div>${addr.city} ${addr.countrycode}&nbsp;&nbsp;${addr.postalcode}</div>
        `;
    }
    else {
        // UK format
        addr.street = addr.street || '';
        return `
        <div>${addr.street}</div>
        <div>${addr.city}</div>
        <div>${addr.postalcode}</div>
        `;
    }
    return JSON.stringify( addr, null, 2 );
};

const input = ( { input: { value, ...input }, meta, handleBlur, ...other } ) => {
    return (
        <input
            defaultValue={value}
            onChange={evt => {
                input.onChange( evt );
            }}
            onBlur={evt => {
                handleBlur( evt );
                input.onBlur( evt );
            }}
            {...other}/>
    );
};
const addressFields = ( props ) => {
    if ( !props.visible || props.hideAddress ) return null;
    const { useAlternateContact, department } = props.formValues;
    const otherDept = department === 'other';
    const onlinefulfillment = props.product.onlinefulfillment;
    const style = props.errorStyle;
    if ( onlinefulfillment && props.office.code != 'uk') {
        return null;
    }
    return (
        <div>
            {!otherDept &&
            <div id="contactAddressSelection">
                <div className="gratisRequestInstructions">
                    <div
                        dangerouslySetInnerHTML={{ __html: props.office.config.shippingAddressInstructions }}/>
                    <div className="paragraph" style={{ paddingLeft: 30 + 'px', fontWeight: 'bold' }}
                         id="gratisDepartmentContact"
                         dangerouslySetInnerHTML={{ __html: formatAddress( props.departmentAddress ) }}>
                    </div>
                    <div className="paragraph">
                        <Field component="input" type="checkbox" name="useAlternateContact"/>
                        Use a different shipping address.
                    </div>
                </div>
            </div>
            }
            {(otherDept || useAlternateContact) &&
            <fieldset title="Shipping Address" id="alternateContactFields" style={{ display: 'block' }}>
                <legend style={{ background: 'inherit' }}> Shipping Address</legend>
                <div className="paragraph">
                    <label style={style( 'streetAddr' ).label} htmlFor="streetAddr">Street Address <span
                        className="requiredAsterisk">*</span>
                    </label>
                    <Field style={style( 'streetAddr' ).input} component="input" id="streetAddr" name="streetAddr"
                           maxLength="35"
                           type="text"/>
                </div>
                <div className="paragraph">
                    <label style={style( 'city' ).label} htmlFor="city">City <span
                        className="requiredAsterisk">*</span>
                    </label>
                    <Field style={style( 'city' ).input} component="input" id="city" name="city" type="text" maxLength="40"/>
                </div>
                {props.office.config.state &&
                <div className="paragraph">
                    <label style={style( 'stateOrProvince' ).label}
                           htmlFor="stateOrProvince">{props.office.config.state} <span
                        className="requiredAsterisk">*</span>
                    </label>
                    <Field style={style( 'stateOrProvince' ).input} component="select" id="stateOrProvince"
                           name="stateOrProvince">
                        <option value="">-- Please Select --</option>
                        {
                            props.office.states && props.office.states.map( ( e, i ) =>
                                <option key={i} value={e.value}>{e.label}</option>
                            )
                        }
                    </Field>
                </div>
                }
                <div className="paragraph">
                    <label style={style( 'postalCode' ).label}
                           htmlFor="postalCode">{props.office.config.postalCode} <span
                        className="requiredAsterisk">*</span>
                    </label>
                    <Field style={style( 'postalCode' ).input} component="input" id="postalCode" name="postalCode"
                           type="text"/>
                </div>
                {!props.office.config.state &&
                <div className="paragraph">
                    <label style={style( 'country' ).label} htmlFor="country">Country <span
                        className="requiredAsterisk">*</span>
                    </label>
                    <Field style={style( 'country' ).input} component="select" id="country" name="country">
                        <option value="">-- Please Select --</option>
                        {
                            props.office.picklists.country && props.office.picklists.country.map( ( e, i ) => {
                                return <option key={i} value={e.value}>{e.label}</option>
                            } )
                        }
                    </Field>
                </div>
                }
            </fieldset>
            }
        </div>
    );
};

function contactFields( props ) {
    if ( !props.showContactForm ) return null;
    const style = props.errorStyle;

    const taStyle = _.defaults( { width: '250px', padding: '2px', minHeight: '100px' }, style( 'message' ).input );
    return (
        <div>
            <div className="paragraph">
                <label style={style( 'subject' ).label} htmlFor="subject">Subject <span
                    className="requiredAsterisk">*</span>
                </label>
                <Field style={style( 'subject' ).input} name="subject" type="text" component="input"/>
            </div>
            <div className="paragraph">
                <label style={style( 'message' ).label} htmlFor="message">Message <span
                    className="requiredAsterisk">*</span>
                </label>
                <Field style={taStyle} name="message" type="text" component="textarea"/>
                <div style={{
                    width      : '250px',
                    paddingLeft: '210px'
                }}>Please let us know the best day and time to contact you.
                </div>
                <div style={{
				   paddingTop: '20px',
                   paddingLeft: '25px'
                }}>Our <a href="https://global.oup.com/privacy">Privacy Policy</a> sets out how Oxford University Press handles your personal information, and your rights to object to your personal information being used for marketing to you or being processed as part of our business activities.
                </div>
				<div style={{
				   paddingLeft: '25px'
                }}>We will only use your personal information for the above purpose.
                </div>
            </div>
        </div>
    )
}

class ContactInformation extends React.Component {

    constructor( props ) {
        super( props );
    }

    updateContact( evt ) {
        console.log( evt );
    }

    render() {
        if ( !this.props.visible ) return null;
        const { useAlternateContact, firstName, lastName, email, department } = this.props.formValues;
        const update = this.updateContact.bind( this );
        const style = this.props.errorStyle;
        return (
            <fieldset id="contactFields">
                <legend>Contact Information</legend>
                <div className="paragraph">
                    <label style={style( 'firstName' ).label} htmlFor="firstName">First Name <span
                        className="requiredAsterisk">*</span>
                    </label>
                    <Field style={style( 'firstName' ).input} name="firstName" type="text" component="input" maxLength="40"/>
                </div>
                <div className="paragraph">
                    <label style={style( 'lastName' ).label} htmlFor="lastName">
                        Last Name
                        <span className="requiredAsterisk">*</span>
                    </label>
                    <Field style={style( 'lastName' ).input} name="lastName" type="text" component={input} maxLength="40"
                           handleBlur={update}/>
                </div>
                <div className="paragraph">
                    <label style={style( 'email' ).label} htmlFor="email">Email <span
                        className="requiredAsterisk">*</span>
                    </label>
                    <Field style={style( 'email' ).input} name="email" type="text" component={input}
                           handleBlur={update}/>
                </div>
                <div className="paragraph">
                 {(this.props.office.code == "us" || this.props.office.code == "ca") ? (
                    <label style={style( 'phone' ).label} htmlFor="phone">Mobile Phone <span
                        className="requiredAsterisk">*</span>
                    </label>
                  ):
                  ( <label style={style( 'phone' ).label} htmlFor="phone"> Phone <span
                                            className="requiredAsterisk">*</span>
                                        </label>
                  )
                 }
                    <Field style={style( 'phone' ).input} name="phone" type="text" component="input"/>
                </div>
                {(this.props.office.code == "us" || this.props.office.code == "ca") &&
                <div class="paragraph"  style={{ padding: 10 + 'px' }}>

                            <Field component="input" type="checkbox" name="smsNotifications"/>
                            I would like to receive notifications via SMS

                            <a style={{marginLeft: 6 + 'px' }} href="https://global.oup.com/ushe/sms-notifications/">What will we use it for?</a>
                        </div>
                }
                {addressFields( this.props )}
                {contactFields( this.props )}
            </fieldset>
        );
    }
}
export default connect( state => ({
    ...state,
    formValues: selector( state, 'useAlternateContact', 'firstName', 'lastName', 'email', 'department' )
}) )( ContactInformation );



// WEBPACK FOOTER //
// ./src/form/components/ContactInformation.jsx